import { AfterViewInit, Component, ElementRef, ViewChild  } from '@angular/core';

@Component({
  selector: 'app-galeria',
  imports: [],
  templateUrl: './galeria.component.html',
  styleUrl: './galeria.component.css'
})
export class GaleriaComponent  {
 @ViewChild('galleryScroll', { static: false }) galleryScroll!: ElementRef;

  lightboxOpen = false;
  lightboxImage = '';

  // ✅ SCROLL CON BOTONES
  scrollLeft() {
    this.galleryScroll.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight() {
    this.galleryScroll.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }

  // ✅ ABRIR LIGHTBOX
  openLightbox(imageSrc: string) {
    this.lightboxImage = imageSrc;
    this.lightboxOpen = true;
  }

  // ✅ CERRAR LIGHTBOX
  closeLightbox() {
    this.lightboxOpen = false;
  }
}